import { toastsSignal, removeToast } from '../../state/ui.store';

export function ToastContainer() {
  const toasts = toastsSignal.value;
  if (toasts.length === 0) return null;

  return (
    <div class="fixed bottom-6 right-6 z-[9999] space-y-2 pointer-events-none">
      {toasts.map(toast => (
        <div
          key={toast.id}
          onClick={() => removeToast(toast.id)}
          class={`toast-alert ${toast.type}`}
        >
          <span>{toast.message}</span>
        </div>
      ))}
    </div>
  );
}
